window.addEventListener("scroll", function () {
    var sc_ctabtn= document.querySelector(".sc_ctabtn");
    var scroll = window.pageYOffset;
    var threshold = 500; // フェードインが始まるスクロール位置

    if (scroll > threshold) {
        sc_ctabtn.style.opacity = "1";
    } else {
        sc_ctabtn.style.opacity = "0";
    }
});